import React, { useState } from 'react';

export default function ClientSettings() {
  const [notif, setNotif] = useState(true);
  const [newsletter, setNewsletter] = useState(false);
  return (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">Paramètres</h1>
      <div className="bg-white p-6 rounded-xl shadow space-y-4">
        <label className="flex items-center gap-3">
          <input type="checkbox" checked={notif} onChange={e => setNotif(e.target.checked)} />
          <span>Recevoir des notifications</span>
        </label>
        <label className="flex items-center gap-3">
          <input type="checkbox" checked={newsletter} onChange={e => setNewsletter(e.target.checked)} />
          <span>S'abonner à la newsletter</span>
        </label>
        <button className="px-4 py-2 bg-[#2563EB] text-white rounded-lg hover:bg-blue-600">Sauvegarder</button>
      </div>
    </div>
  );
}